export const getStrapiImage = (image, format = null) => {
  // Strapi returns an object with attributes.url as the main file
  // and attributes.formats which contains resized versions (small, medium, thumbnail, etc).
  const attributes = image?.data?.attributes || image?.attributes;
  if (!attributes) return "";

  if (format) {
    const fmt = attributes.formats?.[format];
    if (fmt?.url) {
      return fmt.url;
    }
  }

  return attributes.url || "";
};

export const getStrapiMimetype = (file) => {
  return file?.data?.attributes?.mime || "";
};

export const getStrapiFileType = (file) => {
  const mime = file?.data?.attributes?.mime?.split("/") || [];
  return mime[0] || "";
};